import { Box, Container, Divider, Grid, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { SectionTitle } from '../../../../shared/styles/HelpCenterStyles'
import useSectionStart, { SectionData } from '../hooks/useSectionStart'
import ButtonBack from "@/contexts/shared/components/buttons/ButtonBack";

const SectionStart = () => {
  const { t } = useTranslation(['helpcenter'])
  const navigate = useNavigate()
  const handleInfo = (section: string, iQuestion: number) => {
    navigate(`/ayuda/comoempezar/info/${section}/${iQuestion}`)
  }

  const data: SectionData = useSectionStart()
  const objSections = ['about-plei', 'sections', 'basic']

  return (
    <Container id="how-to-start" sx={{ padding: 0, marginTop: 6.25 }} maxWidth="xl">
      <Box>
        <ButtonBack />
      </Box>

      <Container maxWidth="md">
        <Box sx={{ mt: 6, mb: 1 }}>
          <SectionTitle>{t('how-start')}</SectionTitle>
          <Typography>{t('welcome-plei')}</Typography>
          <Box sx={{ mt: 2, mb: 2 }} />
        </Box>

        <Box sx={{ display: 'grid', gap: 8 }}>
          <Grid container spacing={4}>
            {data.client
              .filter((sections: any, index) => sections[objSections[index]] !== undefined)
              .map((sections: any, index) => (
                <Grid key={sections[objSections[index]].title} item xs={12} md={6}>
                  <Box sx={{ pb: 2, pt: 2 }}>
                    <Typography variant="subtitle1">{sections[objSections[index]].title}</Typography>
                    <List component="nav">
                      {sections[objSections[index]].content.map((section: any, index2: number) => (
                        <div key={section.question}>
                          <ListItem disablePadding>
                            <ListItemButton onClick={() => handleInfo(objSections[index], index2)}>
                              <ListItemText primary={section.question} />
                            </ListItemButton>
                          </ListItem>
                          <Divider />
                        </div>
                      ))}
                    </List>
                  </Box>
                </Grid>
              ))}
          </Grid>
        </Box>
      </Container>
    </Container>
  )
}

export default SectionStart
